import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import {Observable} from "rxjs";
import {ScheduleAnalytics} from "../../models/scheduleAnalytics";
import {HttpHeaders} from "@angular/common/http";
import {Schedule} from "../../models/schedule";

export class ScheduleAnalyticsDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.SCHEDULE_ANALYTICS, apiHelper);
    }

    public getRecords(id: string): Observable<IRawRecord[]> {
        let url = this.apiHelper.getServiceName() + this.getResource() + `/records/${id}`;
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'GET', null, null, headers);
    }

    public find(filters: Object): Observable<ScheduleAnalytics[]> {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/find';
        let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
        return this.apiHelper
            .apiCall(
                url,
                'POST',
                null,
                filters,
                headers
            );
    }

    public ingest(id: string): Observable<ScheduleAnalytics> {
        let url: string = this.apiHelper.getServiceName() + this.getResource() + `/ingest/${id}`;
        let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
        return this.apiHelper
            .apiCall(
                url,
                'GET',
                null,
                null,
                headers
            );
    }

    public archive(id: string): Observable<any> {
        let url: string = this.apiHelper.getServiceName() + this.getResource() + `/archive/${id}`;
        let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
        return this.apiHelper
            .apiCall(
                url,
                'DELETE',
                null,
                null,
                headers
            );
    }

    public getSchedulesByAnalytics(scheduleAnalytics: ScheduleAnalytics[]): Observable<Schedule[]> {
        let url: string = this.apiHelper.getServiceName() + this.getResource() + '/getSchedulesByAnalytics';
        let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
        return this.apiHelper
            .apiCall(
                url,
                'POST',
                null,
                scheduleAnalytics,
                headers
            );
    }
}

export interface IRawRecord {
    adCode: string | null;
    station: string;
    length: number;
    show: string;
    days: string[];
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    dayPart: string;
    count: number;
}
